// extracted by mini-css-extract-plugin
export var numpadContainer = "_nl-1";
export var phoneButton = "_nl-0";